import * as React from "react";
import type { SVGProps } from "react";
const SvgIconCircleThree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25}
    height={25}
    viewBox="0 0 496.158 496.158"
    {...props}
  >
    <path
      d="M248.082.003C111.07.003 0 111.061 0 248.085c0 137 111.07 248.07 248.082 248.07 137.006 0 248.076-111.07 248.076-248.07C496.158 111.061 385.088.003 248.082.003"
      style={{
        fill: "#18a09f",
      }}
    />
    <path
      d="M319.637 269.711q-3.957-9.593-11.792-17.505-7.838-7.91-19.263-14.063 11.865-9.96 18.237-20.435 6.372-10.471 6.372-25.122 0-11.131-4.395-20.801c-4.395-9.67-7.276-12.108-13.037-16.992q-8.644-7.323-20.361-11.206-11.721-3.88-25.928-3.882-16.26 0-29.443 4.614c-13.183 4.614-16.139 7.155-22.046 12.231q-8.863 7.619-13.477 16.04-4.614 8.425-4.614 16.04-.001 7.911 4.907 12.671 4.906 4.762 10.767 4.761 4.979 0 8.789-1.758 3.807-1.758 5.273-4.834a529 529 0 0 1 5.493-12.158q3-6.444 6.372-10.547 3.367-4.1 9.155-6.592 5.785-2.49 14.722-2.49 13.182 0 20.947 8.13 7.763 8.131 7.764 19.409 0 14.796-9.741 22.705-9.743 7.91-23.218 7.91h-6.006q-10.401.001-15.674 4.321-5.274 4.322-5.273 11.353 0 7.179 4.395 11.206 4.394 4.03 12.451 4.028 1.758.001 7.91-.586 6.151-.585 9.082-.586 16.698 0 26.074 9.741 9.374 9.743 9.375 26.88 0 11.573-5.493 20.361c-5.493 8.788-8.302 10.279-13.916 13.257q-8.425 4.469-17.505 4.468-15.822 0-24.536-9.888-8.718-9.887-16.333-30.249-1.174-3.369-4.98-5.786-3.811-2.417-7.91-2.417-8.204.001-13.696 5.2-5.493 5.202-5.493 13.696 0 6.592 4.614 16.699c4.614 10.107 7.617 13.257 13.623 19.556s13.646 11.549 22.925 15.747q13.915 6.298 31.494 6.299 17.284 0 31.567-5.493c14.283-5.493 17.748-8.739 24.683-15.234q10.399-9.74 15.747-22.192 5.346-12.45 5.347-25.781 0-11.129-3.955-20.726"
      style={{
        fill: "#fff",
      }}
    />
  </svg>
);
export default SvgIconCircleThree;
